module.exports={
	"Form": "MixSpecificationViewManifest",
	"Scope": "MixSpecification-View",
	"Descriptors":
	{
		"MixSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixSpecification-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "MixSpecification-View-Identity",
				"Group": "MixSpecification-View-Identity"
			}
		},
		"MixSpecificationDetails.Code":
		{
			"Name": "Code",
			"Hash": "MixSpecification-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "MixSpecification-View-Identity",
				"Group": "MixSpecification-View-Identity"
			}
		},
		"MixSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixSpecification-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "MixSpecification-View-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "MixSpecification-View-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "MixSpecification-View-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.ApprovalDate":
		{
			"Name": "Approval Date",
			"Hash": "MixSpecification-View-ApprovalDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.ApprovingIDUser":
		{
			"Name": "Approving IDUser",
			"Hash": "MixSpecification-View-ApprovingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-View-Details",
				"Group": "MixSpecification-View-Details"
			}
		},
		"MixSpecificationDetails.IDMixSpecification":
		{
			"Name": "IDMix Specification",
			"Hash": "MixSpecification-View-IDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.GUIDMixSpecification":
		{
			"Name": "GUIDMix Specification",
			"Hash": "MixSpecification-View-GUIDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixSpecification-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixSpecification-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixSpecification-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixSpecification-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-View-DataAudit",
				"Group": "MixSpecification-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixSpecification-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixSpecification-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixSpecification-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixSpecification-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixSpecification-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixSpecification-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
